import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { TraitCondition } from '../trait.reference.model';
import { TraitFilterContext } from './trait-filter-context';
import { MultiTraitQueryContext } from '../multi-trait-query-context';
import { MultiTraitQueryService } from '../multi-trait-query.service';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
    selector: 'jhi-step-setup-the-trait-filter',
    styleUrls: ['./step-setup-the-trait-filter.component.css'],
    templateUrl: './step-setup-the-trait-filter.component.html'
})
export class StepSetupTheTraitFilterComponent implements OnInit {
    isLoading: boolean;
    @Output() next = new EventEmitter<void>();
    @Output() back = new EventEmitter<void>();
    @Input() active = false;
    protected readonly TraitCondition = TraitCondition;

    constructor(private alertService: AlertService,
                private jhiLanguageService: JhiLanguageService,
                public traitFilterContext: TraitFilterContext,
                private multiTraitQueryService: MultiTraitQueryService,
                public queryContext: MultiTraitQueryContext) {
    }

    async ngOnInit() {
        this.isLoading = true;
        try {
            await Promise.all([
                this.loadNumericTraits(),
                this.loadCharacterTraits(),
                this.loadCategoricalTraits()
            ]);
        } finally {
            this.isLoading = false;
        }
    }

    isNextDisable(): boolean {
        return this.isLoading && this.traitFilterContext.areAllTraitsDropped() || this.traitFilterContext.areNumericInvalidLimits();
    }

    onNext(): void {
        if (!this.isNextDisable()) {
            this.next.emit();
        }
    }

    onBack(): void {
        this.back.emit();
    }

    async loadNumericTraits(): Promise<void> {
        if (this.traitFilterContext.hasNumericTraits()) {
            return;
        }
        try {
            const response = await this.multiTraitQueryService
                .getNumericTraits(this.queryContext.getTraitFilter())
                .toPromise();

            this.traitFilterContext.numericTraits =
                (response.body ? response.body : []).map(trait => ({
                    ...trait,
                    condition: TraitCondition.KEEP_ALL
                }));
        } catch (error) {
        }
    }

    async loadCharacterTraits(): Promise<void> {
        if (this.traitFilterContext.hasCharacterTraits()) {
            return;
        }
        try {
            const response = await this.multiTraitQueryService
                .getCharacterTraits(this.queryContext.getTraitFilter())
                .toPromise();

            this.traitFilterContext.characterTraits =
                (response.body ? response.body : []).map(trait => ({
                    ...trait,
                    condition: TraitCondition.KEEP_ALL
                }));


        } catch (error) {
        }
    }

    async loadCategoricalTraits(): Promise<void> {
        if (this.traitFilterContext.hasCategoricalTraits()) {
            return;
        }

        try {
            const response = await this.multiTraitQueryService
                .getCategoricalTraits(this.queryContext.getTraitFilter())
                .toPromise();

            this.traitFilterContext.categoricalTraits =
                (response.body ? response.body : []).map(trait => ({
                    ...trait,
                    condition: TraitCondition.KEEP_ALL
                }));

        } catch (error) {
        }
    }

}
